export default __webpack_public_path__ + "static/media/naraciLogo.95323a3a.png";